//| THREE.JS Camera movement with mouse:
//https://codepen.io/misterkidult/pen/dybgapB

import Vue from "vue";
import Vuex from "vuex";

//import { GLTFLoader } from 'three-full/sources/loaders/GLTFLoader.js';
//import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'

import {
  OrbitControls,
  GLTFLoader,
  TextureLoader,
  Texture,
  FBXLoader,
  Scene,
  TrackballControls,
  PerspectiveCamera,
  WebGLRenderer,
  Color,
  FogExp2,
  CylinderBufferGeometry,
  MeshBasicMaterial,
  MeshStandardMaterial,
  //CylinderGeometry,
  MeshPhongMaterial,
  Mesh,
  DirectionalLight,
  AmbientLight,
  LineBasicMaterial,
  Geometry,
  Vector3,
  Line,
  Box3
} from "three-full";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appData:[],
    width: 0,
    height: 0,
    camera: null,
    controls: null,
    scene: null,
    renderer: null,
    orbControls:null,
    axisLines: [],
    pyramids: []

  },
  getters: {
    CAMERA_POSITION: state => {
      return state.camera ? state.camera.position : null;
    }
  },
  mutations: {
    SET_APP_DATA(state,appData)
    {
      state.appData = appData;      
    },
    SET_VIEWPORT_SIZE(state, { width, height }) {
      state.width = width;
      state.height = height;
    },
    INITIALIZE_RENDERER(state, el) {
      state.renderer = new WebGLRenderer({ antialias: true,alpha: true });
      state.renderer.setPixelRatio(window.devicePixelRatio);
      state.renderer.setSize(state.width, state.height);
      el.appendChild(state.renderer.domElement);
    },
    INITIALIZE_CAMERA(state) {
      state.camera = new PerspectiveCamera(
        // 1. Field of View (degrees)
        60,
        // 2. Aspect ratio
        state.width / state.height,
        // 3. Near clipping plane
        1,
        // 4. Far clipping plane
        1000
      );
      state.camera.position.z = 300;

    },
    INITIALIZE_CONTROLS(state) {
      state.controls = new TrackballControls(
        state.camera,
        state.renderer.domElement
      );
      state.controls.rotateSpeed = 1;
      state.controls.zoomSpeed = 1;
      state.controls.panSpeed = 1;
      state.controls.noZoom = false;
      state.controls.noPan = false;
      state.controls.staticMoving = false;
      state.controls.dynamicDampingFactor = 0.1;
      state.controls.keys = [65, 83, 68];
    },
    UPDATE_CONTROLS(state) {
      state.controls.update();
    },
    INITIALIZE_SCENE(state) {

      //https://www.youtube.com/watch?v=ZtK70Tb9uqg
      //Unreal Bloom Pass - Three.js Post-Processing Tutorial

      state.scene = new Scene();
      //state.scene.background = new Color(0x202020);
      //state.scene.fog = new FogExp2(0xcccccc, 0.002);
      var geometry = new CylinderBufferGeometry(0, 10, 30, 4, 1);
      var material = new MeshPhongMaterial({
        color: 0xffffff,
        flatShading: true
      });

      /*
      //Add random triangles:
      for (var i = 0; i < 5; i++) {
        var mesh = new Mesh(geometry, material);
        mesh.position.x = (Math.random() - 0.5) * 1000;
        mesh.position.y = (Math.random() - 0.5) * 1000;
        mesh.position.z = (Math.random() - 0.5) * 1000;
        mesh.updateMatrix();
        mesh.matrixAutoUpdate = false;
        state.pyramids.push(mesh);
      }
      */

/*
      var mesh1 = new Mesh(geometry, material);
      mesh1.position.x = 0;
      mesh1.position.y = 0;
      mesh1.position.z = 0;
      mesh1.updateMatrix();
      mesh1.matrixAutoUpdate = false;
      state.pyramids.push(mesh1);
 */
      state.scene.add(...state.pyramids);

      const geometryX = new CylinderBufferGeometry( 25, 25, 150, 32 );
      //const materialX = new MeshBasicMaterial( {color: 0xffff00} );
      const mat2 = new MeshBasicMaterial( {color: 0xff0000} );
      
      //for wireframe:
      const mat1 = new MeshStandardMaterial();
      mat1.wireframe = true;

      //wireframe test:
      //MeshStandardMaterial

      const cylinderX = new Mesh( geometryX,mat1);//, materialX );
      cylinderX.position.x = 0;
      cylinderX.position.y = 0;
      cylinderX.position.z = 0;
      //state.scene.add( cylinderX );
      
      //var textureLoader = new TextureLoader();
      //var texture = textureLoader.load("https://images.pexels.com/photos/172289/pexels-photo-172289.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2");
      //var texture = textureLoader.load("models/baking_seven.jpg");
        //'models/c1.png');
      //texture.flipY = false;


      //working code 1: ////////////////////////////////////////////////
      //working code 1: ////////////////////////////////////////////////
      //working code 1: ////////////////////////////////////////////////
       const loader = new GLTFLoader();
      let filepath = "http://localhost:8080/models/seven_working.gltf";
      //let filepath = "https://cdn.vev.design/private/pK53XiUzGnRFw1uPeFta7gdedx22/4brjc-beverage%20can.glb";
      //seven_working.gltf";
      loader.load(filepath, (gltf)=> 
      {
          var model = gltf.scene;
          model.traverse ((o) => {
            if (o.isMesh==true){
              console.log("o===> mesh : "+o.isMesh);
            }
        } );  
        gltf.scene.scale.set(20,20,20);
        gltf.scene.position.set(0, -110, 0);
        state.scene.add(gltf.scene);
        state.renderer.render(state.scene, state.camera);
      });
        //END working code 1: ////////////////////////////////////////////////
       //END working code 1: ////////////////////////////////////////////////
       //END working code 1: ////////////////////////////////////////////////



/*       const loader = new GLTFLoader();
      let filepath = "http://localhost:8080/models/SEVEN3.gltf";//models/SEVEN3.glb";
      loader.load(filepath, (gltf)=> 
      {
        gltf.scene.scale.set(20,20,20);
        gltf.scene.position.set(0, -110, 0);
        state.scene.add(gltf.scene);
        state.renderer.render(state.scene, state.camera);
      });      
 */

/*       , undefined, function ( error ) { 
        alert(error)     ;
        console.error( error );      
      } );
 */ 

      // lights
      var lightA = new DirectionalLight(0xffffff);
      lightA.position.set(1, 1, 1);
      state.scene.add(lightA);
      
      var lightB = new DirectionalLight(0x002288);
      lightB.position.set(-1, -1, -1);
      state.scene.add(lightB);

      var lightC = new AmbientLight(0x222222);
      state.scene.add(lightC);

      // Axis Line 1
      var materialB = new LineBasicMaterial({ color: 0x0000ff });
      var geometryB = new Geometry();
      geometryB.vertices.push(new Vector3(0, 0, 0));
      geometryB.vertices.push(new Vector3(0, 1000, 0));
      var lineA = new Line(geometryB, materialB);
      state.axisLines.push(lineA);

      // Axis Line 2
      var materialC = new LineBasicMaterial({ color: 0x00ff00 });
      var geometryC = new Geometry();
      geometryC.vertices.push(new Vector3(0, 0, 0));
      geometryC.vertices.push(new Vector3(1000, 0, 0));
      var lineB = new Line(geometryC, materialC);
      state.axisLines.push(lineB);

      // Axis 3
      var materialD = new LineBasicMaterial({ color: 0xff0000 });
      var geometryD = new Geometry();
      geometryD.vertices.push(new Vector3(0, 0, 0));
      geometryD.vertices.push(new Vector3(0, 0, 1000));
      var lineC = new Line(geometryD, materialD);
      state.axisLines.push(lineC);

      state.scene.add(...state.axisLines);
    },
    RESIZE(state, { width, height }) {
      state.width = width;
      state.height = height;
      state.camera.aspect = width / height;
      state.camera.updateProjectionMatrix();
      state.renderer.setSize(width, height);
      state.controls.handleResize();
      state.renderer.render(state.scene, state.camera);
    },
    SET_CAMERA_POSITION(state, { x, y, z }) {
      if (state.camera) {
        state.camera.position.set(x, y, z);
      }
    },
    RESET_CAMERA_ROTATION(state) {
      if (state.camera) {

        //state.camera.rotation.set(0, 0, 0);
        //state.camera.quaternion.set(0, 0, 0, 1);
        //state.camera.up.set(0, 1, 0);
        //state.controls.target.set(0, 0, 0);
        //state.camera.updateProjectionMatrix();
        //state.renderer.render(state.scene, state.camera);

        state.controls.reset();
  
      }
    },
    HIDE_AXIS_LINES(state) {
      state.scene.remove(...state.axisLines);
      state.renderer.render(state.scene, state.camera);
    },
    SHOW_AXIS_LINES(state) {
      state.scene.add(...state.axisLines);
      state.renderer.render(state.scene, state.camera);
    },
    HIDE_PYRAMIDS(state) {
      state.scene.remove(...state.pyramids);
      state.renderer.render(state.scene, state.camera);
    },
    SHOW_PYRAMIDS(state) {
      state.scene.add(...state.pyramids);
      state.renderer.render(state.scene, state.camera);
    }
  },
  actions: {
    loadAppData({state,commit,dispatch})
    {
      var apiURL = "data/appData.json";
      fetch(apiURL, 
        {
          method: "GET",
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          headers: {"Content-Type": "application/json;charset=UTF-8",'Access-Control-Allow-Origin': '*'},
      })
      .then(function(response) { return response.json();})
      .then(function(response)
      {
        commit('SET_APP_DATA',response);
      }        
      );
    },    
    INIT({ state, commit }, { width, height, el }) {
      return new Promise(resolve => {
        commit("SET_VIEWPORT_SIZE", { width, height });
        commit("INITIALIZE_RENDERER", el);
        commit("INITIALIZE_CAMERA");
        commit("INITIALIZE_CONTROLS");
        commit("INITIALIZE_SCENE");

        // Initial scene rendering
        state.renderer.render(state.scene, state.camera);

        // Add an event listener that will re-render
        // the scene when the controls are changed
        state.controls.addEventListener("change", () => {
          state.renderer.render(state.scene, state.camera);
        });

        resolve();
      });
    },
    ANIMATE({ state, dispatch }) {
      window.requestAnimationFrame(() => {
        dispatch("ANIMATE");
        state.controls.update();
      });
    }
  }
});
